// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `group-member-state-indicator {
  width: 1em;
  height: 1em;
}
group-member-state-indicator img {
  width: inherit;
  height: inherit;
  background-color: var(--motes-dark);
  border-radius: 0.5em;
}
group-member-state-indicator svg-icon {
  display: flex;
}
group-member-state-indicator svg-icon.ready {
  color: var(--motes-highlight-color-dark);
}
group-member-state-indicator svg-icon.idle {
  color: var(--motes-gray);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/group-member-state-indicator/group-member-state-indicator.component.scss"],"names":[],"mappings":"AAAA;EAEI,UAAA;EACA,WAAA;AAAJ;AAEI;EACI,cAAA;EACA,eAAA;EACA,mCAAA;EACA,oBAAA;AAAR;AAGI;EACI,aAAA;AADR;AAGQ;EACI,wCAAA;AADZ;AAIQ;EACI,wBAAA;AAFZ","sourcesContent":["group-member-state-indicator {\n    // The size of this component is determined by the font-size of the parent component (to align with the implementation of <svg-icon>)\n    width: 1em;\n    height: 1em;\n\n    img {\n        width: inherit;\n        height: inherit;\n        background-color: var(--motes-dark);\n        border-radius: 0.5em;\n    }\n\n    svg-icon {\n        display: flex;\n        \n        &.ready {\n            color: var(--motes-highlight-color-dark);\n        }\n\n        &.idle {\n            color: var(--motes-gray);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
